import { styled, Text, TextTag, TokenTextAppearance } from "@volkswagen-onehub/components-core";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import useFiltersCountQuery from "../../api/use-filters-count-query";
import { useAppliedFilterStore } from "../../store/filtersv2";
import { getTranslations } from "../../translations";
import { FiltersResponse, FiltersResponseKey, ModelFilterOption, ResponseSelector } from "../../types";

const SkeletonContainer = styled.div`
  margin-top: 8px;
  display: grid;
  row-gap: 8px;
`;

const CountContainer = styled(Text)`
  display: flex;
  flex-direction: column;
  row-gap: 0;
  span {
    display: block;
  }
`;

interface Props {
  color: string;
  label?: string;
  modelKey: string;
  disableOption: (bool: boolean) => void;
}

export const ModelOptionDetails = ({modelKey, disableOption}: Props) => {
  const { labels } = getTranslations();
  const { applied } = useAppliedFilterStore();
  const { category: categories } = applied;

  const [ modelDetails, setModelDetails ] = useState<ModelFilterOption | undefined>();

  const getModelOptions: ResponseSelector<FiltersResponse, ModelFilterOption[]> = res => res[FiltersResponseKey.MODEL];
  const { isLoading, data: modelOptions } = useFiltersCountQuery<FiltersResponse, ModelFilterOption[]>({select: getModelOptions});

  const getCountLine = (key: keyof ModelFilterOption, label: string) => {
    return <span><span className="bold">{ modelDetails?.[key] as unknown as string}</span> { label } </span>;
  };

  useEffect(() => {
    const model = (modelOptions as ModelFilterOption[])?.filter(option => option.value === modelKey)[0];
    setModelDetails(model);
  }, [modelOptions])

  useEffect(() => {
    if (modelDetails) {
      const count = modelDetails.new + modelDetails.used + (modelDetails?.demo || 0);
      const selected = applied?.model?.includes(modelDetails.value);
      const disable = !Boolean(count) && !selected;
      disableOption(disable);
    }
  }, [applied, modelDetails]);

  return (
    isLoading
    ? <SkeletonContainer>
      <Skeleton width="80" height="20" borderRadius="0" />
      <Skeleton width="120" height="20" borderRadius="0" />
    </SkeletonContainer>
    : <CountContainer className="count" tag={TextTag.p} appearance={TokenTextAppearance.bigcopy100}>
      {
        categories?.includes('new') || !categories?.length
        ? getCountLine("new", labels?.new_short)
        : null
      }
      {
        categories?.includes('used') || categories?.includes('certified') || !categories?.length
        ? getCountLine('used', labels?.used_short)
        : null
      }
      {
        categories?.includes('demo') && modelDetails?.demo
        ? getCountLine('demo', labels.demo_short)
        : null
      }
    </CountContainer>
  );
};
